import { defineStore } from "pinia";

import type { Theme } from "../api/portal";

export type { Theme };

// The user portal's accent colours. style.css points primary at the one the page
// is marked with (utils/portalAccent.ts).
export const ACCENT_THEMES = ["teal", "grape", "iceberg", "rose", "offsite"] as const;
export type AccentTheme = (typeof ACCENT_THEMES)[number];

// The last theme seen, so the login page paints in the right accent before the
// server answers. queries/theme.ts reads and refreshes it.
export const useThemeStore = defineStore("theme", {
  state: () => ({
    theme: null as Theme | null,
    themeFetchedAt: null as number | null,
  }),
  persist: {
    storage: "local",
  },
});
